import * as React from "react";
import Select from "react-select";
import jfetch from "../../utils/jfetch";

interface IProps {
  userContext?: IUserContextData;
}

interface IState {
  approvers: any[];
  users: any[];
  selectedOption?: any;
}

export class ApproversList extends React.Component<IProps, IState> {
  state: Readonly<IState> = {
    approvers: [],
    users: []
  };

  componentDidMount() {
    const orgId = this.props.userContext!.organization.data.id;
    this.getUserData(`/approvers/CrystalBall/${orgId}`, "approvers");
    this.getUserData(`/approvers/CrystalBall/${orgId}/unassigned`, "users");
  }

  getUserData = async (url, list) => {
    const users = await jfetch.get<IJsonApiResponse<IUserRecord>>(url);
    if (users.data) {
      this.setList(users.data, list);
    }
  };

  setList = (userData, list) => {
    const newList = userData
      .map((user) => {
        return {
          value: user.id,
          label: `${user.attributes.name} [${user.attributes.jobTitle ? user.attributes.jobTitle : "No Title"}]`,
          name: user.attributes.name,
          jobTitle: user.attributes.jobTitle
        };
      });
    const stateObj = {};
    stateObj[list] = [...this.state[list], ...newList];
    this.setState(stateObj);
  };

  addApprover = async () => {
    const selectedOption = this.state.selectedOption;
    if (selectedOption) {
      const orgId = this.props.userContext!.organization.data.id;
      const response = await jfetch.post(`/approvers/CrystalBall/${orgId}`, {
        user: selectedOption
      });
      if (response.status === "ok") {
        const user = this.state.users.find((e) => selectedOption.value === e.value);
        const newAproversList = [...this.state.approvers, user];
        const newUserList = this.state.users.slice();
        newUserList.splice(
          this.state.users.map(e => e.value).indexOf(user.value), 1
        );
        this.setState({
          approvers: newAproversList,
          selectedOption: null,
          users: newUserList
        });
      }
    }
  };

  removeApprover = async (user, idx) => {
    const response = await jfetch.delete(`/approvers/CrystalBall/${user.value}`);
    if (response.status === "ok") {
      const newApproversList = this.state.approvers.slice();
      const newUserList = this.state.users.slice();
      newApproversList.splice(idx, 1);
      newUserList.push(user);
      this.setState({approvers: newApproversList, users: newUserList});
    }
  };

  render() {
    const { approvers, users, selectedOption } = this.state;
    return (
      <>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Job Title</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {approvers.map((a, idx) => {
              return (
                <tr key={idx}>
                  <td>{a.name}</td>
                  <td>{a.jobTitle}</td>
                  <td>
                    <button
                      onClick={() => this.removeApprover(a, idx)}
                      className="btn-theme-danger"
                      style={{ height: "100%" }}
                    >
                      <i className="fa fa-times"/>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="columns">
          <div className="column">
            <Select
              options={users}
              value={selectedOption}
              onChange={(option) =>
                this.setState({selectedOption: option})
              }
            />
          </div>
          <div className="column">
            <button onClick={this.addApprover} className="btn btn-theme-primary">Add</button>
          </div>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/crystal_ball/ApproversList.tsx